import axios from '@/utils/axios'

export const getMLLatestCost = (payload) => {
    return axios.get('/ml_latest_cost', {
        params: payload
    })
}

export const getMLLatestCostDetail = (payload) => {
    return axios.get(`/ml_latest_cost_detail/${payload}`)
}

export const caclAllML = (payload) => {
    return axios.post('/calc_all_ml', payload)
}

export const caclOneML = (payload) => {
    return axios.post('/calc_ml_cost_one_field', {
        params: payload
    })
}